import ColorAndIconMixin from '@/mixins/content-icon-color.js';
import courseMixins from '@/mixins/templates/course';

export default {
  mixins : [ColorAndIconMixin, courseMixins],
  props  : {
    topic: {
      type    : Object,
      default : () => ({})
    },
    isOpenOnBottomSheet: {
      type    : Boolean,
      default : false
    }
  },
  methods: {
    getActionIcon(topic) {
      if (topic.isBlockedContentByConditional) {
        return 'mdi-lock';
      }

      return topic.viewed ? 'mdi-check-circle-outline' : 'mdi-checkbox-blank-circle-outline';
    },
    handleTopicClick(topic) {
      if (topic.isBlockedContentByConditional) {
        this.$nuxt.$emit('changeIsOpenConditionalsListModal', {
          conditionals        : topic.conditionals,
          isAccessCodeEnabled : topic.isAccessCodeEnabled
        });
      } else {
        this.openTopic(this.topic, topic.id);
      }
    }
  }
};
